<modal
  [id]="id()"
  [header]="header()"
  [closeButtonEnabled]="true"
  [showHeaderDivider]="true"
  [showFooterDivider]="false"
  [widthClass]="widthClass()"
  [heightClass]="heightClass()"
  [enableBackdropClose]="true"
  (onCloseModal)="onModalClose()"
>
  <div
    slot="body"
    class="tw-flex tw-flex-col tw-font-inter"
    [ngClass]="
      isTemplateStep()
        ? 'tw-h-full tw-min-h-0 tw-overflow-hidden'
        : 'tw-my-2'
    "
  >
    @if (isLoading()) {
      <div class="tw-flex tw-flex-col sm:tw-flex-row tw-gap-4 tw-w-full" aria-busy="true" aria-label="Loading invitation templates">
        @for (placeholder of [1, 2]; track placeholder) {
          <div
            class="tw-flex tw-flex-1 tw-flex-col tw-items-center tw-justify-center tw-gap-4 tw-h-[120px] tw-min-h-[120px] tw-shrink-0 tw-box-border tw-p-3 tw-rounded-lg tw-border tw-border-solid tw-border-gray-200 tw-bg-white"
          >
            <div class="tw-h-10 tw-w-10 tw-shrink-0 tw-rounded-full tw-bg-gray-200 tw-animate-pulse"></div>
            <div class="tw-h-4 tw-w-16 tw-rounded tw-bg-gray-200 tw-animate-pulse"></div>
          </div>
        }
      </div>
    } @else if (step() === InvitationTemplatesStep.CHANNEL) {
      <div class="tw-flex tw-flex-col sm:tw-flex-row tw-gap-4 tw-w-full">
        @for (channel of channels; track channel.id) {
          <button
            type="button"
            class="tw-group tw-flex tw-flex-1 tw-flex-col tw-items-center tw-justify-center tw-gap-4 tw-h-[120px] tw-min-h-[120px] tw-shrink-0 tw-box-border tw-p-3 tw-rounded-lg tw-border tw-border-solid tw-cursor-pointer tw-transition-colors tw-duration-200 focus:tw-outline-none"
            [ngClass]="
              selectedChannelId() === channel.id
                ? 'tw-bg-blue-50 tw-border-blue-600'
                : 'tw-bg-white tw-border-gray-200 hover:tw-bg-gray-100 hover:tw-border-gray-300'
            "
            [attr.aria-pressed]="selectedChannelId() === channel.id"
            (click)="onChannelClick(channel)"
          >
            <div
              class="tw-flex tw-h-10 tw-w-10 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-transition-colors tw-duration-200"
              [ngClass]="selectedChannelId() === channel.id ? 'tw-bg-white' : 'tw-bg-blue-50 group-hover:tw-bg-white'"
            >
              @if (channel.id === 'email') {
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" class="tw-shrink-0">
                  <path d="M8 8.7312L15.42 2.3776C15.1351 2.13553 14.7739 2.00181 14.4 2H1.6C1.22614 2.00181 0.864917 2.13553 0.58 2.3776L8 8.7312Z" fill="#1C64F2" />
                  <path
                    d="M9 9.9816C8.70884 10.2043 8.35296 10.3259 7.9864 10.328C7.6448 10.3287 7.31227 10.218 7.0392 10.0128L0 3.9872V12.4C0 12.8243 0.168571 13.2313 0.468629 13.5314C0.768687 13.8314 1.17565 14 1.6 14H14.4C14.8243 14 15.2313 13.8314 15.5314 13.5314C15.8314 13.2313 16 12.8243 16 12.4V3.9872L9 9.9816Z"
                    fill="#1C64F2"
                  />
                </svg>
              } @else if (channel.id === 'whatsapp') {
                <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" class="tw-shrink-0 tw-w-4 tw-h-4">
                  <g clip-path="url(#clip0_invitation_templates_whatsapp)">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M9.9974 1.66797C5.3949 1.66797 1.66406 5.3988 1.66406 10.0013C1.66406 11.5763 2.10156 13.0513 2.8624 14.308L2.11906 16.8346C2.07638 16.9797 2.07357 17.1336 2.11093 17.2801C2.14829 17.4267 2.22444 17.5604 2.33136 17.6673C2.43829 17.7743 2.57205 17.8504 2.71858 17.8878C2.86511 17.9251 3.01899 17.9223 3.16406 17.8796L5.69073 17.1363C6.98963 17.9222 8.47925 18.3367 9.9974 18.3346C14.5999 18.3346 18.3307 14.6038 18.3307 10.0013C18.3307 5.3988 14.5999 1.66797 9.9974 1.66797ZM8.1124 11.8871C9.79823 13.5721 11.4074 13.7946 11.9757 13.8155C12.8399 13.8471 13.6816 13.1871 14.0091 12.4213C14.0504 12.326 14.0654 12.2214 14.0525 12.1184C14.0396 12.0153 13.9993 11.9176 13.9357 11.8355C13.4791 11.2521 12.8616 10.833 12.2582 10.4163C12.1323 10.3292 11.9775 10.2943 11.8263 10.3188C11.6751 10.3434 11.5393 10.4255 11.4474 10.548L10.9474 11.3105C10.9211 11.3515 10.8801 11.3809 10.8329 11.3926C10.7856 11.4044 10.7357 11.3977 10.6932 11.3738C10.3541 11.1796 9.8599 10.8496 9.5049 10.4946C9.1499 10.1396 8.8399 9.66797 8.66573 9.35047C8.64413 9.31013 8.63789 9.26333 8.64816 9.21875C8.65842 9.17416 8.6845 9.1348 8.72156 9.10797L9.49156 8.5363C9.60145 8.44075 9.67237 8.30813 9.69081 8.16369C9.70924 8.01924 9.67392 7.87306 9.59156 7.75297C9.21823 7.2063 8.78323 6.5113 8.1524 6.05047C8.07098 5.99147 7.97562 5.95469 7.87567 5.94373C7.77573 5.93277 7.67466 5.94802 7.5824 5.98797C6.81573 6.3163 6.1524 7.15797 6.18406 8.0238C6.2049 8.59214 6.4274 10.2013 8.1124 11.8871Z"
                      fill="#1C64F2"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_invitation_templates_whatsapp">
                      <rect width="20" height="20" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              }
            </div>
            <span
              class="tw-text-sm tw-font-medium tw-leading-normal tw-text-center tw-transition-colors tw-duration-200"
              [ngClass]="selectedChannelId() === channel.id ? 'tw-text-gray-900' : 'tw-text-gray-700 group-hover:tw-text-gray-900'"
            >
              {{ channel.label }}
            </span>
          </button>
        }
      </div>
    } @else if (step() === InvitationTemplatesStep.WHATSAPP) {
      <div class="tw-flex tw-h-full tw-min-h-0 tw-flex-1 tw-flex-col tw-overflow-hidden">
        <app-whatsapp-invite-templates
          [selectedTemplateId]="whatsappSelectedTemplateId()"
          (selectedTemplateIdChange)="whatsappSelectedTemplateId.set($event)"
        />
      </div>
    } @else if (step() === InvitationTemplatesStep.EMAIL) {
      <div class="tw-flex-1 tw-min-h-0 tw-overflow-y-auto">
        <app-custom-template
          [invitationInfo]="invitationInfo()"
          [event]="event()"
          [eventTimings]="eventTimings()"
          [selectedPersonaSlug]="selectedPersonaSlug()"
          [eventId]="eventId()"
          [organizationId]="organizationId()"
        />
      </div>
    }
  </div>

  <div slot="footer">
    @if (!isLoading() && isTemplateStep()) {
      <div
        class="tw-flex tw-w-full tw-flex-col-reverse tw-gap-3 tw-shrink-0 tw-px-6 tw-pb-6 tw-font-inter lg:tw-flex-row lg:tw-items-center lg:tw-justify-between"
      >
        @if (!isSendFlow()) {
          <button
            type="button"
            class="tw-flex tw-h-[41px] lg:tw-h-[52px] tw-w-full lg:tw-w-auto tw-items-center tw-justify-center tw-gap-2 tw-rounded-lg tw-border tw-border-solid tw-border-gray-200 tw-bg-white tw-px-5 lg:tw-px-6 tw-py-2.5 lg:tw-py-3.5 tw-text-sm lg:tw-text-base tw-font-medium tw-leading-normal tw-text-gray-800 tw-font-inter tw-cursor-pointer"
            [disabled]="isSavingOrSendingTest()"
            (click)="onBack()"
          >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" class="tw-shrink-0">
              <path
                d="M10.6667 2.66669L5.33333 8.00002L10.6667 13.3334"
                stroke="#1F2A37"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            Back
          </button>
        }

        <div
          class="tw-flex tw-w-full tw-flex-col-reverse tw-gap-3 lg:tw-w-auto lg:tw-flex-row lg:tw-items-center lg:tw-gap-3"
          [ngClass]="isSendFlow() ? 'lg:tw-ml-auto' : null"
        >
          <button
            type="button"
            class="tw-flex tw-h-[41px] lg:tw-h-[52px] tw-w-full lg:tw-w-auto tw-items-center tw-justify-center tw-gap-2 tw-overflow-hidden tw-rounded-lg tw-border tw-border-solid tw-border-blue-600 tw-bg-white tw-px-5 lg:tw-px-6 tw-py-2.5 lg:tw-py-3.5 tw-text-sm lg:tw-text-base tw-font-medium tw-leading-normal tw-text-blue-600 tw-font-inter tw-cursor-pointer"
            [disabled]="isSavingOrSendingTest() || !canSendTest()"
            (click)="onSendTestCta()"
          >
            {{ sendTestCtaLabel() }}
          </button>

          <button
            type="button"
            class="tw-flex tw-h-[41px] lg:tw-h-[52px] tw-w-full lg:tw-w-auto tw-items-center tw-justify-center tw-gap-2 tw-rounded-lg tw-border-0 tw-bg-blue-600 tw-px-5 lg:tw-px-6 tw-py-2.5 lg:tw-py-3.5 tw-text-sm lg:tw-text-base tw-font-medium tw-leading-normal tw-text-white tw-font-inter tw-cursor-pointer"
            [disabled]="isSavingOrSendingTest()"
            (click)="onPrimaryCta()"
          >
            {{ primaryCtaLabel() }}
          </button>
        </div>
      </div>
    }
  </div>
</modal>
